import * as React from "react";
import ProgressPoints from "./ProgressPoints";

export default function BlackDecemberPoints(props) {
  return (
    <div className="points">
      <div className="points-header">
        <h2>Sua Pontuação</h2>
        <span className="date-range">
          Progressão de <span>09/12/2019</span> a <span>06/01/2020</span>
        </span>
      </div>
      <ProgressPoints {...props} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/welcome/black-december/BlackDecemberPoints.tsx